import React, { useState, useEffect } from 'react';

const NotificationPanel = ({ onClose }) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState(null);
  const [isPushEnabled, setIsPushEnabled] = useState(false);

  // Fetch notifications
  useEffect(() => {
    fetchNotifications();
    checkPushSubscription();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await fetch('http://45.32.108.70:5001/api/notifications');
      const data = await response.json();
      if (data.success) {
        setNotifications(data.data);
        const unread = data.data.filter(n => !n.is_read).length;
        setUnreadCount(unread);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  const checkPushSubscription = async () => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.getSubscription();
      setSubscription(subscription);
      setIsPushEnabled(!!subscription);
    }
  };

  const markAsRead = async (id) => {
    try {
      await fetch(`http://45.32.108.70:5001/api/notifications/${id}/read`, {
        method: 'PUT'
      });
      setNotifications(prev =>
        prev.map(n => n.id === id ? { ...n, is_read: true } : n)
      );
      setUnreadCount(prev => Math.max(0, prev - 1));
    } catch (error) {
      console.error('Error marking as read:', error);
    }
  };

  const markAllAsRead = async () => {
    try {
      await fetch(`http://45.32.108.70:5001/api/notifications/read-all?user_id=`, {
        method: 'PUT'
      });
      setNotifications(prev =>
        prev.map(n => ({ ...n, is_read: true }))
      );
      setUnreadCount(0);
    } catch (error) {
      console.error('Error marking all as read:', error);
    }
  };

  const subscribeToPush = async () => {
    try {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: 'YOUR_PUBLIC_VAPID_KEY' // Replace with your VAPID key
      });
      
      // Send subscription to server
      const response = await fetch('http://45.32.108.70:5001/api/notifications/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          endpoint: subscription.endpoint,
          keys: subscription.toJSON().keys,
          user_id: null
        })
      });
      
      if (response.ok) {
        setIsPushEnabled(true);
        alert('✅ Push သတိပေးချက်များ ဖွင့်ပြီးပါပြီ။');
      }
    } catch (error) {
      console.error('Error subscribing to push:', error);
      alert('❌ Push သတိပေးချက် ဖွင့်၍မရပါ။');
    }
  };

  const unsubscribeFromPush = async () => {
    try {
      if (subscription) {
        await subscription.unsubscribe();
        await fetch(`http://45.32.108.70:5001/api/notifications/subscribe?endpoint=${subscription.endpoint}`, {
          method: 'DELETE'
        });
        setIsPushEnabled(false);
        alert('✅ Push သတိပေးချက်များ ပိတ်ပြီးပါပြီ။');
      }
    } catch (error) {
      console.error('Error unsubscribing:', error);
    }
  };

  const getPriorityColor = (priority) => {
    const colors = {
      critical: '#dc3545',
      high: '#f59e0b',
      medium: '#3b82f6',
      normal: '#94a3b8',
      low: '#94a3b8'
    };
    return colors[priority] || '#94a3b8';
  };

  const getPriorityIcon = (priority) => {
    const icons = {
      critical: '🔴',
      high: '🟠',
      medium: '🟡',
      normal: '🔵',
      low: '⚪'
    };
    return icons[priority] || '📩';
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      right: 0,
      width: '400px',
      height: '100vh',
      background: 'rgba(15, 23, 42, 0.98)',
      backdropFilter: 'blur(12px)',
      borderLeft: '1px solid #334155',
      zIndex: 999,
      padding: '20px',
      overflowY: 'auto',
      color: 'white'
    }}>
      {/* Close Button */}
      <button 
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: '#ef4444',
          border: 'none',
          borderRadius: '50%',
          width: '30px',
          height: '30px',
          color: 'white',
          fontSize: '16px',
          cursor: 'pointer'
        }}
      >
        ✕
      </button>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ color: '#3b82f6' }}>🔔 အကြောင်းကြားချက်များ</h2>
        {unreadCount > 0 && (
          <span style={{
            background: '#ef4444',
            color: 'white',
            borderRadius: '50%',
            padding: '2px 10px',
            fontSize: '12px'
          }}>
            {unreadCount}
          </span>
        )}
      </div>

      {/* Push Notification Controls */}
      <div style={{
        background: '#1e293b',
        padding: '15px',
        borderRadius: '12px',
        marginBottom: '20px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
              📲 Push သတိပေးချက်များ
            </div>
            <div style={{ fontSize: '11px', color: '#94a3b8' }}>
              {isPushEnabled ? 'သတိပေးချက်များ ဖွင့်ထားပြီး' : 'သတိပေးချက်များ ပိတ်ထားပါသည်'}
            </div>
          </div>
          <button
            onClick={isPushEnabled ? unsubscribeFromPush : subscribeToPush}
            style={{
              padding: '8px 16px',
              background: isPushEnabled ? '#ef4444' : '#22c55e',
              border: 'none',
              borderRadius: '6px',
              color: 'white',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '12px'
            }}
          >
            {isPushEnabled ? 'ပိတ်ရန်' : 'ဖွင့်ရန်'}
          </button>
        </div>
      </div>

      {/* Mark All as Read */}
      {unreadCount > 0 && (
        <button
          onClick={markAllAsRead}
          style={{
            width: '100%',
            padding: '8px',
            background: '#3b82f6',
            border: 'none',
            borderRadius: '6px',
            color: 'white',
            cursor: 'pointer',
            marginBottom: '15px',
            fontSize: '12px'
          }}
        >
          အားလုံးဖတ်ပြီးမှတ်ရန်
        </button>
      )}

      {/* Notifications List */}
      {loading ? (
        <div style={{ textAlign: 'center', color: '#94a3b8', padding: '50px 0' }}>
          ⏳ ဒေတာများ စုဆောင်းနေသည်...
        </div>
      ) : notifications.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#94a3b8', padding: '50px 0' }}>
          📭 အကြောင်းကြားချက် မရှိသေးပါ
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {notifications.map(notif => (
            <div
              key={notif.id}
              onClick={() => markAsRead(notif.id)}
              style={{
                background: notif.is_read ? '#1e293b' : 'rgba(59, 130, 246, 0.15)',
                padding: '15px',
                borderRadius: '10px',
                cursor: 'pointer',
                borderLeft: `4px solid ${getPriorityColor(notif.priority)}`,
                transition: 'all 0.2s',
                opacity: notif.is_read ? 0.7 : 1
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
                <span>{getPriorityIcon(notif.priority)}</span>
                <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{notif.title}</span>
                {!notif.is_read && (
                  <span style={{
                    background: '#3b82f6',
                    borderRadius: '50%',
                    width: '8px',
                    height: '8px',
                    display: 'inline-block',
                    marginLeft: 'auto'
                  }} />
                )}
              </div>
              <div style={{ fontSize: '13px', color: '#94a3b8', marginBottom: '8px' }}>
                {notif.message}
              </div>
              <div style={{ fontSize: '10px', color: '#64748b' }}>
                {new Date(notif.created_at).toLocaleString('my-MM')}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Water Level Alert Section */}
      <div style={{
        marginTop: '20px',
        padding: '15px',
        background: '#1e293b',
        borderRadius: '12px',
        border: '1px solid #334155'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '20px' }}>🌊</span>
          <div>
            <div style={{ fontWeight: 'bold', fontSize: '13px' }}>ရေမှတ်သတိပေးချက်</div>
            <div style={{ fontSize: '11px', color: '#94a3b8' }}>
              ရေမှတ် ၁၂၀၀ စင်တီမီတာကျော်ပါက အလိုအလျောက်သတိပေးမည်
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .notification-panel {
            width: 100% !important;
            left: 0 !important;
            border-left: none !important;
          }
        }
      `}</style>
    </div>
  );
};

export default NotificationPanel;